import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import utils from "@utils/index";
import NonRKPayInvoiceEstimatesService from "@services/NonRKPayInvoiceEstimatesService";
import { NONRKPAY_INVOICE_STATUSES } from "@constants/index";

const NonRKPayEstimateActionsBanner = ({ nonRKPayInvoiceDetailHook, router, invoiceSent, setInvoiceSent }) => {
    const { lang } = global;
    const {
        invoiceState: {
            isEstimate,
            finalized,
            statusId,
            estimateId,
        },
        confirmationModal,
    } = nonRKPayInvoiceDetailHook;
    const [estimateActions, setEstimateActions] = useState(null);
    const [loadingActions, setLoadingActions] = useState(false);

    const navigateToEstimate = () => {
        router.push(`/payments/manualinvoice?id=${estimateId}&estimate=true`);
    };

    const showLinkedEstimateActionsModal = () => {
        confirmationModal.current.openModal({
            title: lang.t("LinkedEstimateActionsModalTitle"),
            message: (
                <span>
                    {lang.t("LinkedEstimateActionsModalBody_")}
                </span>
            ),
            confirmButton: lang.t("LinkedEstimateActionsButton"),
            cancelButton: lang.t("Cancel"),
            onConfirm: navigateToEstimate,
        });
    };

    const fetchEstimateActions = async () => {
        try {
            if (!isEstimate &&
                finalized &&
                estimateId != null &&
                statusId === NONRKPAY_INVOICE_STATUSES.PAID &&
                estimateActions === null
            ) {
                setLoadingActions(true);
                const { data } = await NonRKPayInvoiceEstimatesService.getEstimateActions(estimateId);
                if (data &&
                    (data.CanBeArchived || (data.RefundableAmount && data.RefundableAmount > 0)
                    )) {
                    setEstimateActions(data);
                }
            }
            else {
                setEstimateActions(null);
            }
        }
        catch (error) {
            utils.notify({
                type: "error",
                message: lang.t("Error Getting Estimate Actions"),
                title: lang.t("Error"),
            });
            setEstimateActions(null);
        }
        finally {
            setLoadingActions(false);
        }
    };

    useEffect(() => {
        if (invoiceSent && !loadingActions) {
            setInvoiceSent(false);
            if (estimateActions) {
                showLinkedEstimateActionsModal();
            }
        }
    }, [estimateActions, invoiceSent, loadingActions]);

    useEffect(() => {
        fetchEstimateActions();
    }, [estimateId, isEstimate, statusId]);

    return (
        <If condition={estimateActions}>
            <div className="container estimate-actions-banner margin-bottom-5">
                <div className="estimate-actions-banner-icon">
                    <i className="info-circle-icon" />
                </div>
                <div className="estimate-actions-banner-content">
                    <span className="estimate-actions-banner-title">
                        {lang.t("EstimateActionsBannerTitle")}
                    </span>
                    <If condition={estimateActions.CanBeArchived}>
                        <p className="estimate-actions-banner-message">
                            {lang.t("EstimateActionsBannerDesc_")}&nbsp;{lang.t("EstimateActionsBannerArchive_")}
                        </p>
                    </If>
                    <If condition={estimateActions.RefundableAmount && estimateActions.RefundableAmount > 0}>
                        <p className="estimate-actions-banner-message">
                            {lang.t("EstimateActionsBannerDesc_")}&nbsp;{lang.t("dynamic.EstimateActionsBannerRefund_", { refundableAmount: utils.currencyFormatter(estimateActions.RefundableAmount) })}
                        </p>
                    </If>
                </div>
            </div>
        </If>
    );
};

NonRKPayEstimateActionsBanner.propTypes = {
    nonRKPayInvoiceDetailHook: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    invoiceSent: PropTypes.bool.isRequired,
    setInvoiceSent: PropTypes.func.isRequired,
};

export default NonRKPayEstimateActionsBanner;
